import { render, staticRenderFns } from "./ObjectGroups.vue?vue&type=template&id=d59d2972&scoped=true&"
import script from "./ObjectGroups.vue?vue&type=script&lang=js&"
export * from "./ObjectGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59d2972",
  null
  
)

export default component.exports